App.namespace.wrap('es6.views.quick_estimate.apple', function (options = {}) {
  const AppleLoginManager = App.es6.shared.apple_login_manager

  const {
    appleUrl,
    appleClientId,
    appleRedirectUri,
    csrfToken,
    callback,
    onError,
    buttonId = 'quick-estimate-submit-apple',
    trackingParams,
  } = options

  const init = (initCallback) => {
    const appleLoginOptions = {
      buttonId,
      appleUrl,
      appleClientId,
      appleRedirectUri,
      csrfToken,
      callback,
      onError,
      autoLoginOnClick: false,
      trackingParams,
    }

    return AppleLoginManager(appleLoginOptions).init(initCallback);
  }

  return {
    init
  }
});
